import FooterSocials from "./FooterSocials";
import { useSettings } from "../../data/content";

function Footer() {
  const settings = useSettings();

  return (
    <footer className="bg-background-light dark:bg-background-dark border-t border-border-light dark:border-border-dark">
      <div className="max-w-5xl mx-auto px-6 py-6 flex items-center justify-between">
        <FooterSocials />

        <div className="flex items-center gap-2">
          {settings.available && (
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" />
              <span className="relative inline-flex rounded-full h-2 w-2 bg-green-400" />
            </span>
          )}
          <span className="font-sans text-xs text-text-muted-light dark:text-text-muted-dark">
            {settings.availabilityLabel}
          </span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
